import axios from '@axios'
import jwtDefaultConfig from '@core/auth/jwt/jwtDefaultConfig'

const BASE_ENDPOINT = `${jwtDefaultConfig.DASHBOARD_ENDPOINT}/product_imports`

export default {
  namespaced: true,

  state: {},
  getters: {},
  mutations: {},

  actions: {
    /**
     * Step 1: Upload file and receive parsed column headers + sample values.
     * @param {Object} ctx
     * @param {Object} payload - { file: File, has_header_row: boolean }
     * @returns {{ import_id, columns: Array<{ index, name, sample_values }> }}
     */
    uploadFile(ctx, { file, hasHeaderRow }) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('has_header_row', hasHeaderRow ? '1' : '0')

      return new Promise((resolve, reject) => {
        axios
          .post(`${BASE_ENDPOINT}/upload`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(response => {
            if (response && response.status === 200) {
              resolve(response.data.data)
            } else {
              reject(new Error('Upload failed'))
            }
          })
          .catch(error => reject(error))
      })
    },

    /**
     * Step 3: Preview the first rows with the chosen column mapping applied.
     * @param {Object} ctx
     * @param {Object} payload - { import_id, column_mapping, has_header_row }
     * @returns {{ total_rows, preview_rows: Array }}
     */
    previewImport(ctx, { importId, columnMapping, hasHeaderRow }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${BASE_ENDPOINT}/${importId}/preview`, {
            column_mapping: columnMapping,
            has_header_row: hasHeaderRow,
          })
          .then(response => {
            if (response && response.status === 200) {
              resolve(response.data.data)
            } else {
              reject(new Error('Preview failed'))
            }
          })
          .catch(error => reject(error))
      })
    },

    /**
     * Step 4: Kick off the actual import job.
     * @param {Object} ctx
     * @param {Object} payload - { import_id, column_mapping, has_header_row }
     * @returns {{ operation_id }}
     */
    startImport(ctx, { importId, columnMapping, hasHeaderRow }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${BASE_ENDPOINT}/${importId}/import`, {
            column_mapping: columnMapping,
            has_header_row: hasHeaderRow,
          })
          .then(response => {
            if (response && (response.status === 200 || response.status === 201)) {
              resolve(response.data.data)
            } else {
              reject(new Error('Import failed'))
            }
          })
          .catch(error => reject(error))
      })
    },

    /**
     * Poll operation status until finished or failed.
     * @param {Object} ctx
     * @param {string} operationId
     * @returns {{ status, imported_count, failed_count, errors }}
     */
    fetchOperationStatus(ctx, operationId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${jwtDefaultConfig.DASHBOARD_ENDPOINT}/product_operations/${operationId}`)
          .then(response => {
            if (response && response.status === 200) {
              resolve(response.data.data)
            } else {
              reject(new Error('Status check failed'))
            }
          })
          .catch(error => reject(error))
      })
    },
  },
}
